export default "__VITE_PUBLIC_ASSET__ab2e4d24__"